import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { ClientTypeInsertService } from '../../service/client-type-insert/client-type-insert.service';
import { LayoutProposta } from '../../../models/layout-proposta';

@Component({
	selector: 'app-client-type-insert',
	templateUrl: './client-type-insert.component.html',
	providers: [
		ClientTypeInsertService,
		HttpModule
	]

})
export class ClientTypeInsertComponent implements OnInit {
	clienttype: FormGroup;
	Nome: string = "";
	Valor:string = "";
	statusClientType: boolean;
	private token;
	public permissoes: any[] = [];
	public layoutProposta: LayoutProposta;

	constructor(fb: FormBuilder, private clienttypeInsertService: ClientTypeInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.layoutProposta = new LayoutProposta();
		this.clienttype = fb.group({
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
			'LayoutProposta' : [0,Validators.compose([Validators.min(1)])],
			'TipoSerasa' : ['',Validators.compose([Validators.min(1)])],
			'Valor': ['', Validators.compose([Validators.required, Validators.maxLength(18)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addClientType(value: any) {
		this.clienttypeInsertService.insertClientType(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Tipo de Cliente cadastrado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/tipo-cliente');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});

	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-cliente');
	}

}



// WEBPACK FOOTER //
// ./src/app/client-type/component/client-type-insert/client-type-insert.component.ts